import { SpinnerComponent } from './spinner.component';

export default angular
  .module('sfMobile.components.spinner', [])
  .component('sfSpinner', SpinnerComponent).name;
